import { render, staticRenderFns } from "./SelectBoxes.vue?vue&type=template&id=00b5ff02&"
import script from "./SelectBoxes.vue?vue&type=script&lang=js&"
export * from "./SelectBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports